import React, { useState, useCallback } from 'react';
import { useLocationSearch } from '../hooks/useLocationSearch';
import { useLocationCoordinates } from '../hooks/useLocationCoordinates';
import { useLocationPagination } from '../hooks/useLocationPagination';
import { PaginationProvider } from '../contexts/PaginationContext';
import LocationLayout from '../components/layout/LocationLayout';
import NoResults from '../components/noResults/NoResults';
import SearchUnavailable from '../components/searchUnavailable/SearchUnavailable';

const Widget = () => {
	// Custom hooks for separation of concerns
	const { paginationData, currentPage, handlePageChange } =
		useLocationPagination();

	// Track current page locations for map pins
	const [currentPageLocations, setCurrentPageLocations] = useState([]);

	// Compose page-change: update both pagination state AND map-pin state
	const composedPageChange = useCallback(
		(data) => {
			handlePageChange(data);
			setCurrentPageLocations(data.paginatedData || []);
		},
		[handlePageChange]
	);

	const {
		isLoading,
		errorMsg,
		noResults,
		tileData,
		locationCount,
		allLocationData,
		showMap,
		range,
		setRange,
		resetTriggers
	} = useLocationSearch(paginationData);

	// Get coordinates from location selection (ws-locations-control)
	const coordinates = useLocationCoordinates();

	// Error state
	if (errorMsg) return <SearchUnavailable isApiError />;

	// Main layout — always rendered so the Google Map instance survives
	// across NoResults ↔ results transitions. Hidden via display:none
	// when NoResults is active.
	return (
		<PaginationProvider
			value={{
				totalCount: locationCount,
				allData: allLocationData,
				onPageChange: composedPageChange,
				resetTriggers,
				currentPage
			}}
		>
			<div className="location-search-container">
				{noResults && (
					<NoResults
						isNoResults
						currentRange={range}
						onRangeChange={setRange}
					/>
				)}
				<div
					style={{
						display: noResults ? 'none' : undefined
					}}
				>
					<LocationLayout
						tileData={tileData}
						showMap={showMap}
						coordinates={coordinates}
						currentPageLocations={currentPageLocations}
						isLoading={isLoading}
					/>
				</div>
			</div>
		</PaginationProvider>
	);
};

export default Widget;
